import { useQuery } from 'react-query';
import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { sms_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';
import {
  orttoCommunicationKeys,
  parseOrttoCommunicationKey,
} from '../../cache-keys/orttoCommunicationKeys.tsx';

export function useOrttoSMSBodies(customerID?: string, marketCountry?: string) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = orttoCommunicationKeys.smsBodies({
    customerID,
    marketCountry,
  });

  return useQuery(
    cacheKey,
    queryFunction(sms_api.getSMSBodies(api), ({ queryKey }) =>
      parseOrttoCommunicationKey(queryKey)
    ),
    {
      enabled: state.user.token.length > 0 && !!customerID && !!marketCountry,
    }
  );
}
